
import React from 'react';

interface StatCardProps {
  title: string;
  value: number;
  type: 'income' | 'expense' | 'balance';
}

const StatCard: React.FC<StatCardProps> = ({ title, value, type }) => {
  const config = {
    income: {
      color: 'text-emerald-500',
      bg: 'bg-emerald-50',
      icon: 'fa-arrow-trend-up',
      border: 'border-emerald-100'
    },
    expense: {
      color: 'text-rose-500',
      bg: 'bg-rose-50',
      icon: 'fa-arrow-trend-down',
      border: 'border-rose-100'
    },
    balance: {
      color: 'text-indigo-500',
      bg: 'bg-indigo-50',
      icon: 'fa-wallet',
      border: 'border-indigo-100'
    },
  };

  const style = config[type];

  return (
    <div className={`neo-card p-6 flex flex-col justify-between h-full border-t-4 ${type === 'income' ? 'border-t-emerald-400' : type === 'expense' ? 'border-t-rose-400' : 'border-t-indigo-400'}`}>
      <div className="flex justify-between items-start mb-4">
        <div>
           <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-1 truncate">{title}</p>
        </div>
        <div className={`w-8 h-8 rounded-lg ${style.bg} ${style.color} flex items-center justify-center text-sm shadow-sm`}>
           <i className={`fa-solid ${style.icon}`}></i>
        </div>
      </div>
      <div>
        <p className="text-2xl font-black text-slate-800 break-words tracking-tight">
          Rp {value.toLocaleString('id-ID')}
        </p>
      </div>
    </div>
  );
};

export default StatCard;
